import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { Lock, Eye, EyeOff } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password.trim());
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-4 grain">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <span className="font-serif text-3xl text-cream">Idea<span className="text-gold"> Events</span></span>
          <p className="overline-label mt-3">Admin Console</p>
        </div>
        <form onSubmit={submit} className="gold-card !border-gold/30 p-8 space-y-5">
          <div className="w-12 h-12 rounded-full bg-gold-deep border border-gold/40 flex items-center justify-center text-gold mx-auto mb-2">
            <Lock className="w-5 h-5" />
          </div>
          <div>
            <label className="text-xs text-muted2 mb-1 block">Email</label>
            <input data-testid="admin-login-email" type="email" autoComplete="username" autoCapitalize="none" autoCorrect="off" spellCheck="false" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full bg-ink border border-gold/25 rounded-lg px-4 py-3 text-cream focus:outline-none focus:border-gold" />
          </div>
          <div>
            <label className="text-xs text-muted2 mb-1 block">Password</label>
            <div className="relative">
              <input data-testid="admin-login-password" type={showPw ? "text" : "password"} autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required
                className="w-full bg-ink border border-gold/25 rounded-lg px-4 py-3 pr-11 text-cream focus:outline-none focus:border-gold" />
              <button type="button" data-testid="admin-login-toggle-password" onClick={() => setShowPw((v) => !v)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-muted2 hover:text-gold" aria-label="Toggle password visibility">
                {showPw ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="btn-gold w-full disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
